import React, { useContext } from 'react';
import { useGuestbookSmartFillAPI } from '../../hooks/useGuestbookSmartfill';
import { getCombinedSuggestions, getCategoriesSuggestions } from '../../utils/suggestionsUtils';
import locationContext from '../../context/locationsContext';
import {
  CITY,
  AIRPORT,
  HOTEL,
  NEIGHBORHOOD,
  REGION,
  POI,
  TRAIN_STATION,
  ADDRESS,
} from '../../constants/categoryConstants';
import SuggestionsList from '../Suggestions/SuggestionsList';

const fallbackCategories = [
  CITY,
  AIRPORT,
  HOTEL,
  NEIGHBORHOOD,
  REGION,
  POI,
  TRAIN_STATION,
  ADDRESS,
];

const GuestbookSmartFill = () => {
  const {
    config: {
      lineOfBusiness,
      maximumResultsToShow,
    },
  } = useContext(locationContext);
  const { suggestions, isLoading, error } = useGuestbookSmartFillAPI();

  if (isLoading || error || suggestions?.length === 0) {
    return null;
  }

  const suggestionsByType = getCombinedSuggestions({
    suggestions,
    recentSearches: [],
    maximumResultsToShow,
    lineOfBusiness,
  });

  const hasCategorizedSuggestions = Object.values(suggestionsByType)
    .some((category) => category?.suggestions?.length > 0);

  const guestbookSuggestionsByType = hasCategorizedSuggestions
    ? suggestionsByType
    : fallbackCategories.reduce((categories, category) => ({
      ...categories,
      [category.key]: getCategoriesSuggestions(category, suggestions),
    }), {});

  return <SuggestionsList suggestions={guestbookSuggestionsByType} />;
};

export default GuestbookSmartFill;
